import React from "react";

// import abcfLogo from "../../assets/images/assets/abcf-logo.jpeg";

import "./style.css";

export default function ConsentScreen({setGameConsent}) {
  return (
    <>
      <div className="container">
        {/* <img className="abcf-logo" src={abcfLogo} alt="logo-aditya-birla" /> */}
        <p>
        Ready for a quick, fun game to learn something new about yourselves? Play this super fast, cool game! Pick your likes/dislikes from a series of fun, intuitive pictures and answer some really simple questions. Voila! you will get a personalized mini-report giving a sneak peek into your personality and preferences! Have fun and start playing!
        </p>

        <button
          className="continue_button"
          onClick={() => {
            setGameConsent(true);
          }}
        >
          CONTINUE TO GAME
        </button>
      </div>
    </>
  );
}
